module.exports = __webpack_public_path__ + "static/media/icon-apto.c225193e.svg";